// YouTube / Vimeo の iframe をアスペクト比維持でレスポンシブ化

document.addEventListener('DOMContentLoaded', () => {
  const videos = Array.from(
    document.querySelectorAll("iframe[src^='https://player.vimeo.com'], iframe[src^='https://www.youtube.com']")
  );
  if (!videos.length) return;

  videos.forEach((v) => {
    v.dataset.aspectRatio = v.height / v.width;
    v.removeAttribute('height');
    v.removeAttribute('width');
  });

  const resize = () => {
    videos.forEach((v) => {
      const w = v.parentElement.clientWidth;
      v.style.width = w + 'px';
      v.style.height = (w * parseFloat(v.dataset.aspectRatio)) + 'px';
    });
  };
  window.addEventListener('resize', resize);
  resize();
});
